import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addActiveMachine } from '@custom/rtk-apis/activeMachine/addActivemachine';
import { AddActiveMachineState } from '@custom/Utils/constants/interfaces';

const initialState: AddActiveMachineState = {
  status: "",
  loading: false,
  error: null,
  msg: null,
};

const addActiveMachineSlice = createSlice({
  name: 'addActiveMachine',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addActiveMachine.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.msg = null;
      })
      // Handle the fulfilled state (successful API call)
      .addCase(addActiveMachine.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload.status;
        state.msg = action.payload.msg;
      })
      // Handle the rejected state (API call failed)
      .addCase(addActiveMachine.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the reducer to be added to the store
export default addActiveMachineSlice.reducer;
